let modal = document.querySelectorAll(".modal");
let btns = document.querySelectorAll(".profile");
let btns2 = document.querySelectorAll(".custom--table");
let btns3 = document.querySelectorAll(".behind-pop-video-btn");
let spans = document.querySelectorAll(".close");
let count = false;
let btnCount = true;

let AAIModal = document.getElementById("AAI-modal");

btns.forEach((btn, i) => btn.addEventListener("click", () => displayModal(i)));
btns2.forEach((btn, i) => btn.addEventListener("click", () => displayModal(i)));
btns3.forEach((btn, i) => btn.addEventListener("click", () => displayModal(i)));
spans.forEach((span, i) => span.addEventListener("click", () => hideModal(i)));

function displayModal(profile) {
  modal[profile].classList.add("show-modal");
}

function hideModal(profile) {
  modal[profile].classList.remove("show-modal");
}

window.onclick = function (event) {
  modal.forEach((m) => {
    if (event.target == m) {
      m.classList.remove("show-modal");
    }
  });

  AAIModal = document.getElementById("AAI-modal");
  if (btnCount && AAIModal) {
    let closeBtn = document.createElement("span");
    closeBtn.innerHTML = `<span id="AAI-modal-close" onclick="AAI_close_modal()">x</span>`;
    // console.log("HERE", AAIModal);
    AAIModal.append(closeBtn);
    btnCount = false;
  }
  if(AAIModal && AAIModal.style.display == "block"){
  if (event.target !== AAIModal && count && !AAIModal.contains(event.target)) {
    AAI_close_modal();
  } else count = true;
}
};

function AAI_close_modal() {
  AAI_close();
  count = false;
}
